import React, { FC } from 'react';

import Loader from '../Loaders/Table';
import Placeholder from '../Placeholders/Table';
import { Container, Header, Row, Caption } from './styles';
import { Props } from './types';

const Orders: FC<Props> = ({ isLoading, orders, ...props }) => {
  if (isLoading) {
    return (
      <Container>
        <Header>
          <Caption>Customer</Caption>
          <Caption>Restaurant</Caption>
          <Caption>Order №</Caption>
          <Caption>Date</Caption>
          <span />
        </Header>
        <Loader opacity={1} />
        <Loader opacity={0.75} />
        <Loader opacity={0.5} />
        <Loader opacity={0.25} />
        <Loader opacity={0} />
      </Container>
    );
  }

  if (orders.length === 0) {
    return <Placeholder />;
  }

  return (
    <Container {...props}>
      <Header>
        <Caption>Customer</Caption>
        <Caption>Restaurant</Caption>
        <Caption>Order №</Caption>
        <Caption>Date</Caption>
        <span />
      </Header>
      {orders.map((order) => (
        <Row key={order.id} order={order} />
      ))}
    </Container>
  );
};

export default Orders;
